module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/ancona.32450d5f6809cff7beb4ac5994e0f0f5.jpg";